/* @flow */

import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

import link from './link';
import introspectionQueryResultData from '../../../schema.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const cache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject: o => (o.uid ? `${o.__typename}.${o.uid}` : null),
});

export const client = new ApolloClient<*>({
  link,
  cache,
  defaultOptions: {
    query: { fetchPolicy: 'no-cache' },
  },
});
